import { useStoryblokState } from '@cinch-nx/data-storyblok'
import { Head } from '@cinch-nx/landing-ui-shared'
import {
  ComponentLayouts,
  StoryblokRendererV2 as StoryblokRenderer,
} from '@cinch-nx/storyblok-utils'
import { Site } from '@cinch-labs/sites-sdk'
import { CollectionLocationProps } from './get-static-props'
import { storyblokComponentsCollections } from './storyblok/data/storyblok-renderer-map'
import { CollectionLocationStory } from './storyblok/storyblok'

export const CollectionLocation = ({
  story,
  site: siteResponse,
  nearestSitesResponse,
  slugBasedFallbackTitle,
  preview,
}: CollectionLocationProps) => {
  const { content } = useStoryblokState<CollectionLocationStory>({
    story,
    enableBridge: preview,
  })

  const SEO = content.SEO?.[0] ?? {}
  const site = siteResponse ? new Site(siteResponse) : undefined
  const siteName =
    site?.getFeatureAttribute('display_name') ?? slugBasedFallbackTitle
  const {
    SectionWithImageV2,
    PreFooterCtaV2,
    NearbyLocations,
    ...remainingComponents
  } = storyblokComponentsCollections

  const componentLayouts: ComponentLayouts = {
    fullWidthWrapper: {
      SectionWithImageV2,
      PreFooterCtaV2,
      NearbyLocations,
    },
    slimWrapper: remainingComponents,
  }

  return (
    <>
      <Head
        {...SEO}
        fallbackTitle={`${siteName} collection location - cinch`}
        fallbackDescription="Just book your 2-hour time slot at checkout and one of our cinch handover specialists will meet you there."
      />
      <article>
        <StoryblokRenderer
          block={content.body}
          components={componentLayouts}
          props={{ site, nearestSitesResponse, slugBasedFallbackTitle }}
        />
      </article>
    </>
  )
}
